import {Component, OnInit} from '@angular/core';
import {education, experience, interests, otherInterests} from './home.data';
import techIcons from './home.icon.data';
import {OrgPersonnel} from '../../models/PortonUser/OrgPersonnel';
import {HAdmin} from '../../models/PortonUser/HAdmin';
import {MOA} from '../../models/PortonUser/MOA';
import {getUserClass} from '../../models/PortonUser/util';
import {PortonUser} from '../../models/PortonUser/PortonUser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls:  ['./home.component.mobile.scss', './home.component.scss']
})
export class HomeComponent implements OnInit {
  education = education;
  experience = experience;
  interests = interests;
  otherInterests = otherInterests;
  techIcons = techIcons;

  constructor() { }

  ngOnInit() {
  }

}
